import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { RouterOutlet, RouterModule, Router } from '@angular/router';
import { NotificationsComponent } from '../notifications/notifications.component';
import { AuthService } from 'app/features/auth/data-access/auth.service';

declare const ngDevMode: boolean | undefined;

@Component({
  selector: 'app-layout',
  templateUrl: './layout.html',
  styleUrls: ['./layout.scss'],
  standalone: true,
  imports: [CommonModule, RouterOutlet, RouterModule, NotificationsComponent],
})
export class LayoutComponent implements OnInit, OnDestroy {
  isCollapsed = false;
  filteredSidebarOptions: Array<{
    label: string;
    iconPath: string;
    route: string;
  }> = [];

  constructor(
    public router: Router,
    public auth: AuthService,
  ) {}

  ngOnInit(): void {
    this.auth.ensureFirebaseAuthOnStartup();
    // Inicializar con todas las opciones por defecto
    this.filteredSidebarOptions = [...this.sidebarOptions];
    this.setupSidebarFiltering();
  }

  ngOnDestroy(): void {}

  private setupSidebarFiltering(): void {
    this.auth.currentUser$.subscribe((user) => {
      const userRole = user?.role?.toLowerCase() || '';
      const isTecnico =
        userRole === 'tecnico' ||
        userRole === 'técnico' ||
        userRole.includes('tecnico');
      const isAdmin =
        userRole === 'admin' ||
        userRole === 'administrador' ||
        userRole.includes('admin');
      const islectura =
        userRole === 'lectura' ||
        userRole === 'lectura' ||
        userRole.includes('lectura');

      // Filtrar opciones del menú según el rol
      this.filteredSidebarOptions = this.sidebarOptions.filter((option) => {
        // Si es técnico, ocultar "Pagos y devoluciones"
        if (isTecnico && option.label === 'Pagos y devoluciones') {
          return false;
        }
        // Solo mostrar "Rescate de articulos" para técnicos
        if (
          option.label === 'Rescate de articulos' &&
          !isTecnico &&
          !isAdmin &&
          !islectura
        ) {
          return false;
        }
        // Solo mostrar "Información oficial" para técnicos y administradores
        if (option.label === 'Información oficial' && !(isTecnico || isAdmin)) {
          return false;
        }
        return true;
      });
    });
  }

  sidebarOptions = [
    {
      label: 'Inicio',
      iconPath: 'assets/img/sidebar-home-vector.png',
      route: '/inicio',
    },
    {
      label: 'Lotes',
      iconPath: 'assets/img/lotes-sidebar-vector.svg',
      route: '/lotes',
    },
    {
      label: 'Subastas',
      iconPath: 'assets/img/subastas-sidebar-vector.svg',
      route: '/subastas',
    },
    {
      label: 'Rescate de articulos',
      iconPath: 'assets/img/rescate-sidebar-vector.svg',
      route: '/rescates',
    },
    {
      label: 'Participantes',
      iconPath: 'assets/img/participantes-sidebar-vector.svg',
      route: '/participantes',
    },
    {
      label: 'Pagos y devoluciones',
      iconPath: 'assets/img/pagos-sidebar-vector.svg',
      route: '/payments',
    },
    {
      label: 'Información oficial',
      iconPath: 'assets/img/informacion-oficial-sidebar-vector.svg',
      route: '/informacion-oficial',
    },
  ];

  activeRoutesMap: Record<string, string[]> = {
    Inicio: ['/inicio'],
    Subastas: [
      '/subastas',
      '/crear-subastas',
      '/verSubasta',
      '/editar-subasta',
      '/infolote',
    ],
    Lotes: [
      '/lotes',
      '/crear',
      '/crear-manual',
      '/completarinfolote',
      '/verLote',
    ],
    'Rescate de articulos': ['/rescates'],
    'Información oficial': ['/informacion-oficial'],
    Participantes: ['/participantes', '/participantes/detalles'],
    Historial: [],
  };

  toggleSidebar() {
    this.isCollapsed = !this.isCollapsed;
  }

  logout() {
    this.auth.logout().subscribe({
      complete: () => {
        // navigation handled inside service; keep here to ensure redirect
        this.router.navigate(['/login']);
      },
    });
  }

  showTitle(): boolean {
    const hiddenRoutes = ['/login', '/inicio'];
    return !hiddenRoutes.includes(this.router.url);
  }
  isOptionActive(label: string, routeFallback: string): boolean {
    const url = this.router.url.split('?')[0].split('#')[0];
    const prefijos = this.activeRoutesMap[label] || [routeFallback];
    return prefijos.some((p) => url === p || url.startsWith(p + '/'));
  }
}
